/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Chat_Ask_User_Asked_ByInputs */



/**
* | output |
* | --- |
* | "Asked by {model}" |
*
* @param {Chat_Ask_User_Asked_ByInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_asked_by = /** @type {((inputs: Chat_Ask_User_Asked_ByInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Asked_ByInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Gefragt von ${i?.model}`)
	return /** @type {LocalizedString} */ (`Asked by ${i?.model}`)
});